import axios from 'axios'
import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { Link as RouterLink } from 'react-router-dom'
import { compose } from 'redux'
import _ from 'underscore'

import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import withSelected from '../../hocs/withData/withSelected'
import Accordion from '../Accordion'
import Button from '../Button'
import PricingTable from '../Content/ModulesScreen/PricingTable'
import TextContent from '../TextContent'
import TableTitle from './TableTitle'

const useStyles = makeStyles({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
})

const amountToPay = 30
const numberOfSlots = 1

const ModulesTable = ({ Selected = {} }) => {
  const [isRequestLoading, setIsRequestLoading] = useState(false)
  const classes = useStyles()
  const DataTable = []

  Object.entries(Selected).forEach(category => {
    if (DataTable.find(row => row.cells[0].text === category[1].cpdCourse)) {
      return
    }

    const modulesWithMultipleCategories = Object.entries(Selected).filter(
      course => course[1].cpdCourse === category[1].cpdCourse
    )

    DataTable.push({
      row: {},
      cells: [
        {
          text: category[1].cpdCourse,
          type: 'text',
          rowSpan: modulesWithMultipleCategories.length,
        },
        {
          text: `${category[1].categoryCode} - ${category[1].categoryDescription}`,
          type: 'text',
        },
      ],
    })

    if (modulesWithMultipleCategories.length > 1) {
      modulesWithMultipleCategories.slice(1).forEach(course => {
        DataTable.push({
          row: {},
          cells: [
            {
              type: 'text',
              text: `${course[1].categoryCode} - ${course[1].categoryDescription}`,
            },
          ],
        })
      })
    }
  })

  const modulesToTake = [
    ...new Set(
      Object.values(Selected)
        .filter(course => course.cpdCourse)
        .map(course => course.cpdCourse)
    ),
  ]

  const isHubRegisteredUser = document.cookie
    .split('; ')
    .find(row => row.startsWith(process.env.REACT_APP_SESSION_AUTH_COOKIE))
    ?.split('=')[1]

  const addCpdRenewalItemsToBasket = async () => {
    setIsRequestLoading(true)

    const baseUrl = process.env.REACT_APP_SUPERAPP_BASE_URL,
      endpoint = process.env.REACT_APP_SUPERAPP_BASKET_ENDPOINT,
      apiUrl = baseUrl + endpoint

    await axios
      .post(
        apiUrl,
        {
          modulesToTake,
          numberOfSlots,
          amountToPay: amountToPay * 100,
        },
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then(() => {
        window.location.href = process.env.REACT_APP_SUPERAPP_BASKET_URL
      })
      .catch(error => {
        const errors = error?.response?.data?.errors
        const message = error?.response?.data?.message

        if (errors?.length) {
          errors?.forEach(errorMessage => toast.error(errorMessage))
          return
        }

        if (message) {
          toast.error(message)
          return
        }

        toast.error('An error occurred adding to the basket')

        return
      })
      .finally(() => {
        setIsRequestLoading(false)
      })
  }

  return (
    <>
      <div className="root">
        <div className="titleSection">
          <TableTitle title="You are required to sit these modules" />
        </div>
        <Paper className={`${classes.root} modules-table paper`}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Modules to Sit</TableCell>
                <TableCell>Categories Selected</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {DataTable.map((row, index) => (
                <TableRow key={`${index}s`}>
                  {row.cells.map(cell => {
                    if (cell.type === 'link') {
                      return (
                        <TableCell key={`${cell.text}${index}s`} rowSpan={cell.rowSpan || 1}>
                          <p>{cell.text}</p>
                        </TableCell>
                      )
                    }
                    return (
                      <TableCell key={`${cell.text}${index}s`} rowSpan={cell.rowSpan || 1}>
                        <p>{cell.text}</p>
                      </TableCell>
                    )
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
        <div className="titleSectionAmount">
          <TableTitle title="Amount to pay" />
          <p className="amountToPay">
            <strong>{` £ ${amountToPay}.00`}</strong>
          </p>
        </div>
        <div className="amountToPayText">
          <p>
            You can purchase the Renewal CPD e-Learning modules below.
            <br />
            <br />
            To do this you need to register as a user of the NOCN Hub. Once registered, you can
            select the Renewal CPD e-Learning you require, pay for them and take the learning at
            home.
            <br />
            <br />
            To register, please click the ‘Checkout’ button (then click the ‘Sign Up’ link on
            the NOCN Hub login page).
            <br />
            <br />
            If you wish to edit your selection please press the &lsquo;Back&lsquo; button below.
          </p>
          <div className="two-button-wrapper">
            <Button classButton="back">
              <RouterLink to="/">Back</RouterLink>
            </Button>
          </div>
        </div>
      </div>

      <Accordion title="Advice and Guidance for Booking Multiple Renewal CPD e-Learning:">
        <TextContent>
          <p>
            You can take up to five (5) CPCS CPD e-Learning modules in a single slot. These can be
            completed anywhere you feel comfortable.
          </p>
        </TextContent>
      </Accordion>
      <div
        className="tables_container"
        style={{
          display: 'flex',
          backgroundColor: 'white',
        }}
      >
        <div style={{ width: '100%', margin: '2em' }}>
          {<h3 style={{ fontWeight: 'bold', margin: '1em 0', padding: '0' }}>NOCN Group</h3>}
          <PricingTable
            pricePerSlot={30}
            tableText={'To start your CPD e-Learning click "Checkout" button below'}
          />
          <Button
            onPress={addCpdRenewalItemsToBasket}
            disabled={amountToPay <= 0 || isRequestLoading}
          >
            {isRequestLoading ? (
              <FontAwesomeIcon icon={faCircleNotch} spin />
            ) : !isHubRegisteredUser ? (
              'Checkout'
            ) : (
              'Checkout'
            )}
          </Button>
        </div>
      </div>
    </>
  )
}

export default compose(withSelected)(ModulesTable)
